import { useParams, usePathname, useRouter } from "next/navigation";
import { useCallback } from "react";


import { appConfig } from "@/configs";
import { PREFERRED_LANGUAGE_COOKIE_NAME } from "@/constants";
import { getNewUrlWithLanguage, setCookie } from "@/utils";

export const useLanguage = () => {
  const params = useParams();
  const pathname = usePathname();
  const router = useRouter();

  const currentLanguage = (params.slug?.[0] as string) || appConfig.settings.language.defaultLanguage;

  const changeLanguage = useCallback(
    (language: string) => {
      const searchParams = typeof window !== "undefined" ? window.location.search : "";
      const newUrl = getNewUrlWithLanguage(pathname, searchParams, language);

      setCookie(PREFERRED_LANGUAGE_COOKIE_NAME, language, 365);
      router.replace(newUrl);
    },
    [pathname, router]
  );

  return {
    language: currentLanguage,
    changeLanguage,
  };
};
